<template>
  <div>
    <van-popup
      v-model="show"
      round
      class="inPop"
    >
      <component
        :is="contract"
        :hidePopup="hidePopup"
      ></component>
    </van-popup>
    <div class="agreement">
      <img
        class="selectImg"
        @click="clickAgree()"
        :src="imgUrlAgreement"
        alt=""
      >
      <span
        class="agreementText"
        @click="clickAgree()"
      >{{text}}</span>
      <!-- <br/> -->
      <span
        class="agreement_content"
        @click="showClick(item.value)"
        v-for="item in list"
        :key="item.value"
      >《{{ item.text }}》</span>
    </div>
  </div>
</template>
<script>
import EnterpriseAuthorizationAgreement from '@/components/FeildTwo/components/EnterpriseAuthorizationAgreement.vue';
import DashuH5 from '@/components/FeildTwo/components/DashuH5.vue';
import GuaranteeServiceContract from '@/components/FeildTwo/components/GuaranteeServiceContract.vue';
import PersonalAuthorizedAgreement from '@/components/FeildTwo/components/PersonalAuthorizedAgreement.vue';
import InformationCheckAndUseAgreement from '@/components/FeildTwo/components/InformationCheckAndUseAgreement.vue';
import PufaOnlineAuth from '@/components/FeildTwo/components/PufaOnlineAuth.vue';
import PufaStatementUse from '@/components/FeildTwo/components/PufaStatementUse.vue';
import pufaPrivacyAgreement from '@/components/FeildTwo/components/pufaPrivacyAgreement.vue';
import pufaServiceAgreement from '@/components/FeildTwo/components/pufaServiceAgreement.vue';
import registerAgreement from '@/components/FeildTwo/components/registerAgreement.vue';
import DaShuInfoContract from '@/components/FeildTwo/components/DaShuInfoContract.vue';
import suningEnterpriseCreditauthorize from '@/components/FeildTwo/components/suningEnterpriseCreditauthorize.vue'; // 苏宁 --《企业征信查询授权书》
import suningPersonalCreditAuthorize from '@/components/FeildTwo/components/suningPersonalCreditAuthorize.vue'; // 苏宁 --《个人征信查询授权书》
import suningPersonalInfoAuthorize from '@/components/FeildTwo/components/suningPersonalInfoAuthorize.vue'; // 苏宁 --《隐私及综合信息查询授权书
import yxEnterpriseInfomationAgree from '@/components/FeildTwo/components/yxEnterpriseInfomationAgree.vue';
import NoSelect from '@/assets/images/weixuanzhong.png';
import Select from '@/assets/images/xuanzhong.png';
import Privacypolicy from '@/components/FeildTwo/components/Privacypolicy.vue'; // 隐私政策

export default {
  name: 'Contract',
  data() {
    return {
      agreeWithAgreement: false,
      contract: '',
      show: false,
      imgUrlAgreement: NoSelect,
    };
  },
  props: {
    list: Array,
    text: {
      type: String,
      default: '本人已经阅读并完全同意：',
    },
    value: Boolean,
    changeArgementFlag: Function,
    argementFlag: Boolean,
  },
  components: {
    EnterpriseAuthorizationAgreement,
    DashuH5,
    PersonalAuthorizedAgreement,
    InformationCheckAndUseAgreement,
    PufaStatementUse,
    PufaOnlineAuth,
    pufaPrivacyAgreement,
    pufaServiceAgreement,
    registerAgreement,
    GuaranteeServiceContract,
    DaShuInfoContract,
    suningEnterpriseCreditauthorize,
    suningPersonalCreditAuthorize,
    suningPersonalInfoAuthorize,
    yxEnterpriseInfomationAgree,
    Privacypolicy,
  },
  mounted() {
  },
  methods: {
    clickAgree() {
      // this.agreeWithAgreement = !this.agreeWithAgreement;
      console.log('我点击了操作');
      this.changeArgementFlag(!this.argementFlag);
      console.log('changeArgementFlag=====', this.changeArgementFlag);
      console.log('wo dianji le caozuo ', this.argementFlag);
      this.imgUrlAgreement = !this.argementFlag ? Select : NoSelect;
      // this.$emit('input', !this.argementFlag);
      // this.$store.dispatch('commonForms/updateCommon', {
      //           agreeWithAgreement:temp
      // })
    },
    showClick(val) {
      const agreeMap = {
        bw_sq: 'EnterpriseAuthorizationAgreement',
        dashu_h5: 'DashuH5',
        pds_sq: 'PersonalAuthorizedAgreement',
        pds_invoice: 'InformationCheckAndUseAgreement',
        spdb_pi: 'PufaOnlineAuth',
        spdb_uspec: 'PufaStatementUse',
        pufa_privacy: 'pufaPrivacyAgreement',
        pufa_service: 'pufaServiceAgreement',
        REGISTERAGREEMENT: 'registerAgreement',
        spdb_guarantee: 'GuaranteeServiceContract',
        dashu_info_contract: 'DaShuInfoContract',
        suningEnterpriseCreditauthorize: 'suningEnterpriseCreditauthorize',
        suningPersonalCreditAuthorize: 'suningPersonalCreditAuthorize',
        suningPersonalInfoAuthorize: 'suningPersonalInfoAuthorize',
        yx_entInfo_sq: 'yxEnterpriseInfomationAgree',
        bw_ys: 'Privacypolicy',
      };
      this.$emit('showPopup', agreeMap[val]);
      this.showPopup(agreeMap[val]);
    },
    showPopup(val) {
      this.contract = val;
      this.show = !this.show;
    },
    hidePopup() {
      this.show = !this.show;
    },
  },
};
</script>
<style scoped>
.inPop {
  width: 90%;
  height: 90%;
  padding: 10px;
}

.inPop >>> .inPop a#close {
  background: none;
  color: #000;
}

.agreement {
  box-sizing: border-box;
  margin-top: 10px;
  margin: 0 15px 0 15px;
  color: #9ea7b4;
  font-size: 12px;
  line-height: 24px;
  letter-spacing: 0;
  text-align: left;
  position: relative;
}
.agreement .agreement_content {
  color: #ff6538;
}
.selectImg {
  width: 12px;
  position: absolute;
  top: 5px;
  left: 0;
}
.seletedColor {
  color: #ff6538;
}
.agreementText {
  margin-left: 20px;
}
</style>
